import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import s from './BaseInput.scss';
var BaseInput = React.forwardRef(function (_a, ref) {
    var isRequired = _a.isRequired, className = _a.className, rest = __rest(_a, ["isRequired", "className"]);
    return (React.createElement(BiInput, __assign({ className: c(s['input'], className), required: isRequired, innerRef: function (node) {
            if (isFunction(ref)) {
                ref(node);
            }
            else if (ref) {
                ref.current = node;
            }
        } }, rest)));
});
BaseInput.displayName = 'BaseInput';
export default BaseInput;
//# sourceMappingURL=BaseInput.js.map